@if (selectedItem()) {
  <div
    odxLayout="flex gap-none"
    class="flex-column w-100 container"
    [ngClass]="{
      'not-extended': sidesheetExtent() === SidesheetExtent.None,
      'partially-extended': sidesheetExtent() === SidesheetExtent.Partially,
      'fully-extended': sidesheetExtent() === SidesheetExtent.Fully,
    }"
  >
    <div odxLayout="flex" class="space-between header">
      <div odxLayout="flex gap-small">
        <h5 class="odx-title-5" [odxTooltip]="title() ?? ''" odxTooltipSize="medium">{{ title() }}</h5>

        @if (selectedItemIsProductOrPlaceholder()) {
          @let group = getGroup(selectedItem()!);
          @if (group) {
            <app-group-number-chip [group]="group"></app-group-number-chip>
          }
        }
      </div>

      <odx-action-group>
        <button odxButton variant="secondary" (click)="close()">
          <odx-icon name="close" size="medium"></odx-icon>
        </button>
      </odx-action-group>
    </div>

    <div class="content">
      @switch (itemType()) {
        @case (ItemType.MeasurementLine) {
          <app-measurement-line-notes [floorplanItem]="selectedItem()!"></app-measurement-line-notes>
        }
        @case (ItemType.ReferenceMeasure) {
          <app-reference-measure-notes [floorplanItem]="selectedItem()!"></app-reference-measure-notes>
        }
        @case (ItemType.Image) {
          <app-image-notes [floorplanItem]="selectedItem()!"></app-image-notes>
        }
        @case (ItemType.Transmitter) {
          <app-transmitter-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.FlameDetector) {
          <app-flame-detector-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.GasWarningCenter) {
          <app-gas-warning-center-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.SignalElement) {
          <app-signal-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.AlarmDevice) {
          <app-alarm-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.PlasticSign) {
          <app-plastic-sign-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.Pipeline) {
          <app-pipeline-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.CableRoute) {
          <app-cable-route-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.ProtectiveTube) {
          <app-protective-tube-notes [floorplanItem]="selectedItem()!"></app-protective-tube-notes>
        }
        @case (ItemType.Wire) {
          <app-wire-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.Placeholder) {
          <app-placeholder-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.Zone) {
          <app-zone-notes [floorplanItem]="selectedItem()!"></app-zone-notes>
        }
        @case (ItemType.AirPath) {
          <app-air-path-notes [floorplanItem]="selectedItem()!"></app-air-path-notes>
        }
        @case (ItemType.PatientMonitor) {
          <app-patient-monitor-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.CentralStation) {
          <app-central-station-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.Telemetry) {
          <app-telemetry-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.Kvm) {
          <app-kvm-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.Display) {
          <app-display-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.Utility) {
          <app-utility-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.FreeText) {
          <app-free-text-notes
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          />
        }
        @case (ItemType.Default) {
          <app-floorplan-item-details
            [floorplanItem]="selectedItem()!"
            [extent]="sidesheetExtent()"
            (toggleExtendedButtonClicked)="toggleExtended()"
          ></app-floorplan-item-details>
        }
      }
    </div>
  </div>
}
